import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  green,
  pink,
  red,
  indigo,
  deepPurple,
  deepOrange,
} from "@mui/material/colors";
import Avatar from "@mui/material/Avatar";
import { Typography, useMediaQuery } from "@mui/material";
import { Box } from "@mui/system";
import AOS from "aos";
import "aos/dist/aos.css";

const CourseSummary = () => {
  const matches = useMediaQuery("(max-width:425px)");
  React.useEffect(() => {
    AOS.init();
  }, []);
  return (
    <Container className="py-5" id="summary">
      <Box display="flex" justifyContent="center" alignItems="center">
        <Typography
          sx={{
            bgcolor: indigo[400],
            p: 1,
            borderRadius: "8px",
            color: "white",
          }}
          align="center"
          fontWeight={600}
          variant={matches ? "h5" : "h4"}
          gutterBottom
          display="inline"
        >
          Course Summary
        </Typography>
      </Box>

      <Box sx={{ bgcolor: deepOrange[50], borderRadius: "8px", pb: 2 }}>
        <Row
          xl={4}
          md={3}
          sm={2}
          xs={1}
          className="justify-content-center g-4 py-2"
        >
          {itemData1.map((item, idx) => (
            <Col
              key={idx}
              className="d-flex flex-column align-items-center"
              data-aos="fade-up"
            >
              <Avatar
                sx={{
                  bgcolor: `${item.color[400]}`,
                  width: 80,
                  height: 80,
                  fontSize: "22px",
                }}
              >
                {item.value}
              </Avatar>

              <Typography gutterBottom variant="subtitle2" component="div">
                {item.more}
              </Typography>

              <Typography
                fontWeight={600}
                gutterBottom
                variant="subtitle2"
                component="div"
              >
                {item.name}
              </Typography>
            </Col>
          ))}
        </Row>
      </Box>
    </Container>
  );
};

export default CourseSummary;

const itemData1 = [
  {
    name: "Hours per Class",
    value: "3",
    more: "3 Hours (2 Sessions per class)",
    color: pink,
  },

  {
    name: "Classes per Week",
    value: "2",
    more: "2 Classes",
    color: green,
  },

  {
    name: "Total No. of classes",
    value: "12",
    more: "12 Classes",
    color: red,
  },

  {
    name: "Number of Professors",
    value: "10",
    more: "10 Professors",
    color: indigo,
  },

  {
    name: "Total No. of Weeks",
    value: "6",
    more: "6 Weeks",
    color: indigo,
  },

  {
    name: "Total No. of Hours",
    value: "36",
    more: "36 Hours",
    color: deepPurple,
  },

  {
    name: "Maximum Student",
    value: "40",
    more: "40 Student's",
    color: deepPurple,
  },
  {
    name: "Classroom",
    value: "Class",
    more: "Research Rider Classroom",
    color: deepOrange,
  },
];

const itemData2 = [
  {
    name: "Total No. of Weeks",
    value: "6",
    more: "6 Weeks",
    color: indigo,
  },

  {
    name: "Total No. of Hours",
    value: "36",
    more: "36 Hours",
    color: deepPurple,
  },

  {
    name: "Maximum Student",
    value: "40",
    more: "40 Student's",
    color: deepPurple,
  },
  {
    name: "Classroom",
    value: "Class",
    more: "Research Rider Classroom",
    color: deepOrange,
  },
];
